import { Box, Container } from "@mui/material";
import TopBar from "./TopBar";

function CenterContent({ open, toggleDrawer, drawerDisabled, children }) {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900],
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "100vh",
        minHeight: "100vh",
        overflow: "hidden",
        "@media print": { overflow: "visible !important" },
      }}>
      <TopBar open={open} toggleDrawer={toggleDrawer} drawerDisabled={drawerDisabled} />

      <Container
        id="center-content-container"
        maxWidth="lg"
        sx={{
          pt: 4,
          pb: "max(32px, env(safe-area-inset-bottom))",
          overflowY: "auto",
          flexGrow: 1,
          "@media print": { mt: 0, pb: 2 },
        }}>
        {children}
      </Container>
    </Box>
  );
}

export default CenterContent;
